<template>
  <section class="scrollable padder">
    <div v-if="loading" class="loading">Loading&#8230;</div>
    <div v-if="showAlert" class="alert alert-danger alert-dismissible">
      <button
        type="button"
        class="close"
        aria-hidden="true"
        @click="closeAlert"
      >
        ×
      </button>
      <h4><i class="icon fa fa-ban"></i> Error!</h4>
      {{ errMessage }}
    </div>
    <section class="panel panel-default">
      <div class="modal-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(addAdminUser)" method="post">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <ValidationProvider
                  name="first-name"
                  rules="required|alpha"
                  v-slot="{ errors }"
                >
                  <label for="sort_order">First Name </label>
                  <input
                    type="text"
                    name="first_name"
                    v-model="first_name"
                    autocomplete="off"
                    data-parsley-trigger="keyup"
                    class="form-control"
                    value=""
                    placeholder="First Name"
                  />
                  <span style="color:red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <ValidationProvider
                  name="last-name"
                  rules="required|alpha"
                  v-slot="{ errors }"
                >
                  <label for="sort_order">Last Name </label>
                  <input
                    type="text"
                    name="last_name"
                    v-model="last_name"
                    autocomplete="off"
                    data-parsley-trigger="keyup"
                    class="form-control"
                    value=""
                    placeholder="Last Name"
                  />
                  <span style="color:red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <ValidationProvider
               name="gender"
                  rules="required"
                  v-slot="{ errors }"
               >
                <label>Gender</label>
                <select
                  class="form-control "
                  v-model="gender"
                  id="gender"
                  name="gender"
                  style="width: 100%;"
                >
                  <option selected value="">Choose Gender </option>
                  <option
                    v-for="(type, value) in genders"
                    :key="type"
                    v-bind:value="type"
                    >{{ value }}</option
                  >
                    
                </select>
                <span style="color:red">{{ errors[0] }}</span>
                </ValidationProvider
               
               >
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <ValidationProvider
                  name="contact-no"
                  rules="required|min:10|max:10"
                  v-slot="{ errors }"
                >
                  <label for="sort_order">Contact No </label>
                  <input
                    type="number"
                    name="contact_no"
                    v-model="contact_no"
                    autocomplete="off"
                    data-parsley-trigger="keyup"
                    class="form-control"
                    value=""
                    placeholder="Contact No"
                  />
                  <span style="color:red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <!-- <div class="col-sm-6">
              <div class="form-group">
                <ValidationProvider
               name="user-role"
                  rules="required"
                  v-slot="{ errors }"
               >
                <label> User Role</label>
                <select
                  class="form-control "
                  v-model="user_role"
                  id="user_role"
                  name="user_role"
                  style="width: 100%;"
                >
                  <option selected value="">Choose User Role </option>
                  <option
                    v-for="(type, value) in userroles"
                    :key="type"
                    v-bind:value="type"
                    >{{ value }}</option
                  >
                </select>
                 <span style="color:red">{{ errors[0] }}</span>
                </ValidationProvider>
               
              </div>
            </div> -->
            <div class="col-sm-6">
              <div class="form-group">
                <ValidationProvider
                  name="email"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <label for="sort_order"> Email </label>
                  <input
                    type="text"
                    v-model="email"
                    autocomplete="off"
                    data-parsley-trigger="keyup"
                    class="form-control"
                    value=""
                    placeholder=" Email"
                  />
                  <span style="color:red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
            <div class="modal-footer" style="text-align: right;">
              <button
                :disabled="saveCompanyProvision"
                id="btn_save"
                type="submit"
                class="btn btn-success  text-center"
              >
                Save
              </button>
              <a
                v-on:click="$emit('hide-admin-add-user')"
                class="btn btn-danger  text-center "
              >
                Close
              </a>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </section>
  </section>
</template>

<script>
import api from "../api";

export default {
  props: ["adminUserId"],
  name: "AddAdminUser",
  data() {
    return {
      first_name: "",
      last_name: "",
      contact_no: "",
      email: "",
      gender: "",
      userroles: this.$store.state.userRoles,
      genders: this.$store.state.gender,
      user_role: "",
      loading: false,
    };
  },
  components: {},
  methods: {
    addAdminUser() {
      this.loading = true;
      const addAdminUser = {
        "user-form": {
          admin_user_id: this.adminUserId,
          first_name: this.first_name,
          last_name: this.last_name,
          contact_no: this.contact_no,
          email: this.email,
          gender: this.gender,
          user_role: 12 // this.user_role,
        },
      };

      if (this.adminUserId > 0) {
        api
          .request("post", "GeneralApis/edit_admin_user", addAdminUser)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.loading = false;
              this.response = data.errormessage;
              return;
            } else {
              this.loading = false;
              alert("succesfully Updated");
              this.$emit("hide-admin-add-user");
            }
        });
      } else {
        api
        .request("post", "GeneralApis/add_admin_user", addAdminUser)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.loading = false;
              this.response = data.errormessage;
              return;
            } else {
              this.loading = false;
              alert("succesfully Added");
              this.$emit("hide-admin-add-user");
            }
        });
      }
    },
    getAdminUser: function() {     
      this.first_name = ""
      this.last_name = ""
      this.gender = ""
      this.contact_no = ""
      this.email = ""
      this.user_role = ""
      this.admin_user_id = ""
      if(this.$props.adminUserId > 0){
      const getuser = {
        filter: {
          admin_user_id: this.$props.adminUserId,
        },
      };
      api
        .request("post", "GeneralApis/get_admin_users", getuser)
        .then((response) => {
          var data = response.data;
          if (data.errorcode) {
            this.response = data.errormessage;
            return;
          } else {
            this.userList = data.userList[0];
            this.first_name = this.userList.first_name;
            this.last_name = this.userList.last_name;
            this.gender = this.userList.gender;
            this.contact_no = this.userList.contact_no;
            this.email = this.userList.email;
            this.user_role = this.userList.user_role;
            this.admin_user_id = this.userList.admin_user_id;
          }
        });
      }
    },
  },
  mounted() {
    this.getAdminUser();
  },
};
</script>
